import type { ScaleSelectorProps, SexScaleData } from "@qendo/profile/journal";
import { type ScaleType, SexType, SexTypeMap } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RadioSelector } from "~/components/form/radio/RadioSelector";

export type SexSelectorProps = ScaleSelectorProps<ScaleType.sex>;

type SexValue = `${SexType}`;
type SexTypeOption = { value: SexValue; label: string };

function toSexValue(sex: SexType | null): SexValue | null {
    return sex === null ? null : `${sex}`;
}
function toSexType(sex: SexValue): SexType {
    return sex === toSexValue(SexType.protected) ? SexType.protected : SexType.unprotected;
}

const SexTypeOptions: SexTypeOption[] = Object.entries(SexTypeMap).map(
    ([value, label]) => ({ value, label }) as SexTypeOption,
);

export const SexSelector = ({ value, onUpdateScale, disabled, zIndex }: SexSelectorProps) => {
    const scale = toSexValue(value?.value);

    const changeScale = (c: SexValue) => {
        if (scale !== c) {
            onUpdateScale({ ...value, value: toSexType(c) } as SexScaleData);
        }
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RadioSelector<SexValue>
                title=""
                options={SexTypeOptions}
                value={scale}
                onValueChange={changeScale}
                columns={2}
                disabled={disabled}
            />
        </FieldGroup>
    );
};
